import React from 'react';
import { Grid } from '@material-ui/core';
import { PortalButton } from 'src/components/Buttons';
import { Config } from 'src/state';
import { t } from 'i18next';
import { onHandleKeyDown } from 'src/utils/onHandleKeyDown';
import { useUrlParameterCheck } from 'src/utils/useUrlParameterCheck';

interface IFooter {
  onConfirm?: () => void;
  onCancel?: () => void;
}

const Footer = ({ onConfirm, onCancel }: IFooter) => {
  const rejectButtonType = Config.isRealkreditDenmark()
    ? 'primary'
    : 'secondary';
  const isFromMvpApp = useUrlParameterCheck('/app');

  return (
    <Grid container wrap="wrap" spacing={2}>
      <Grid item xs={isFromMvpApp ? 6 : 12} sm={6}>
        <PortalButton
          style={{ display: 'flex', justifyContent: 'center' }}
          colorType={isFromMvpApp ? 'secondary' : 'primary'}
          onClick={onConfirm}
          fullWidth
          onKeyDown={e => onHandleKeyDown(e, onConfirm)}
          aria-label={t('ContinueSession')}
        >
          {t('SessionContinueButton')}
        </PortalButton>
      </Grid>
      <Grid item xs={isFromMvpApp ? 6 : 12} sm={6}>
        <PortalButton
          colorType={isFromMvpApp ? 'mvpRed' : rejectButtonType}
          onClick={onCancel}
          fullWidth
          onKeyDown={e => onHandleKeyDown(e, onCancel)}
          aria-label={t('LogOffEndSession')}
        >
          {t('LogOff')}
        </PortalButton>
      </Grid>
    </Grid>
  );
};

export default Footer;
